module.exports = __webpack_public_path__ + "img/book-self.b10dddef.png";